import script from "./NewRsvpWithAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRsvpWithAttendance.vue?vue&type=script&setup=true&lang=js"

import "./NewRsvpWithAttendance.vue?vue&type=style&index=0&id=8993396c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8993396c"]])

export default __exports__